import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { AUTH_QUERY_KEYS } from '../constants';
import { authService } from '../services';
import { isUnauthenticated } from '../utils';
import { useAuthStore } from './use-auth-store';

/**
 * Carrega a sessao atual (GET /auth/me) e mantem a store Zustand sincronizada.
 */
export function useSession() {
  const setUser = useAuthStore((state) => state.setUser);
  const clear = useAuthStore((state) => state.clear);

  const query = useQuery({
    queryKey: AUTH_QUERY_KEYS.me,
    queryFn: () => authService.me(),
    staleTime: 60_000,
    retry: false,
  });

  useEffect(() => {
    if (query.data) {
      setUser(query.data.user);
    } else if (query.error && isUnauthenticated(query.error)) {
      clear();
    }
  }, [query.data, query.error, setUser, clear]);

  return {
    user: query.data?.user ?? null,
    session: query.data?.session ?? null,
    permissions: query.data?.permissions ?? null,
    isLoading: query.isLoading,
    isAuthenticated: Boolean(query.data),
    error: query.error,
    refetch: query.refetch,
  };
}
